import { api } from '@/lib/api';
import { qk, queryClient } from './query';

/** Prime per-call caches with one request before rendering the history cards. */
export async function primeCallAnalyses(callIds: number[]) {
  const now = Date.now();
  const missing = [...new Set(callIds)].filter((id) => {
    const state = queryClient.getQueryState(qk.aiCall(id));
    return !state || state.data === undefined || state.isInvalidated || now - state.dataUpdatedAt >= 30_000;
  });
  if (!missing.length) return true;
  const previous = new Map(missing.map((id) => [id, queryClient.getQueryState(qk.aiCall(id))]));
  const records = await api.ai.listAnalysesForCalls(missing);
  for (const id of missing) {
    // A mutation or an active progress poll may have completed during this batch.
    const current = queryClient.getQueryState(qk.aiCall(id));
    const before = previous.get(id);
    if (current?.data !== before?.data || current?.dataUpdatedAt !== before?.dataUpdatedAt) continue;
    queryClient.setQueryData(qk.aiCall(id), records[id] ?? null);
  }
  return true;
}
